module.exports = __webpack_public_path__ + "static/media/A1.31821cae.png";